import { Checkbox } from "antd";
import DatePickerComponent from "../../common/date-picker";
import DropdownComponent from "../../common/dropdown-input";
import ModalView from "../../common/modal";
import MultiSelectInput from "../../common/multi-select-input";
import Text from "../../common/typography/text";
import Button from "../../common/button/button";
import { useEffect, useState } from "react";
import LazyEntitySelect from "../../common/multi-select-input/GenericAsyncSelect";
import APIService from "../../Service/APIService";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth } from '../AuthProvider.js';

const NewReport = ({ handleRunNewReport, openRunNewReport, reportID }) => {
  const { user } = useAuth();
  const userData = user;
  const navigate = useNavigate();
  const [timeframe, setTimeframe] = useState({
    label: "This week",
    value: "week",
  });
  const [customStartDate, setCustomStartDate] = useState();
  const [customEndDate, setCustomEndDate] = useState();
  const [accounts, setAccounts] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [productGroups, setProductGroups] = useState([]);
  const [regions, setRegions] = useState([]);
  const [states, setStates] = useState([]);
  const [orderType, setOrderType] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [includeVoidedInvoices, setIncludeVoidedInvoices] = useState(false);
  const [onlyRealizedSales, setOnlyRealizedSales] = useState(false);
  const [existingFilters, setExistingFilters] = useState(null);
  const apiPath = "/GetReportFilterOptions";

  const runReport = async () => {
    const postObj = {
      ID: reportID ?? 0,
      Accounts: accounts,
      Distributors: distributors,
      Manufacturers: manufacturers,
      ProductGroups: productGroups,
      Regions: regions,
      OrderType: orderType && orderType.length > 0 ? orderType : [{ label: 'Both', value: 'Both' }],
      InvoiceType: invoiceType,
      IncludeVoidedInvoices: includeVoidedInvoices,
      OnlyRealizedSales: onlyRealizedSales,
      CustomStartDate: customStartDate,
      CustomEndDate: customEndDate,
      Type: "Sales",
      ReportName: "",
      CreatedBy: "",
      CreatedByUserID: userData.UserID,
      CreatedByEmail: "",
      Timeframe: timeframe.value,
      States: states,
    };
    if (reportID) {
      const apiService = new APIService();
      const response = await apiService.addDataToBackend(postObj, "UpdateSalesReport?type=Update");
      console.log(response);
      // navigate to Report/:id
      window.location.reload();
    }
    else{
      const apiService = new APIService();
      const response = await apiService.addDataToBackend(postObj, "CreateSalesReport");
      console.log(response);
      // navigate to Report/:id
      const repId = response?.data?.ID;
      if (repId) {
        // Replace with your navigation logic
        console.log(`Navigating to Report/${repId}`);
        navigate(`/Reports/${repId}`);
      }
    }
  }

  const getExistingReport = async () => {
    const apiService = new APIService();
    const response = await apiService.getDataFromBackend(`GetSalesReportByID?ReportID=${reportID}`);
    console.log(response.data);
    const filters = JSON.parse(response.data.FiltersJSON);
    setExistingFilters(filters);
    console.log("Existing Filters: ", filters);
    setAccounts(filters.Accounts.map(acc => ({ label: acc.AccountName, value: acc.ID, RegionID: acc.RegionID })));
    setDistributors(filters.Distributors.map(dist => ({ label: dist.DistributorName, value: dist.ID })));
    setManufacturers(filters.Manufacturers.map(manuf => ({ label: manuf.ManufacturerName, value: manuf.ID })));
    setProductGroups(filters.ProductGroups.map(prodGroup => ({ label: prodGroup.ProductGroupName, value: prodGroup.ID })));
    setRegions(filters.Regions.map(region => ({ label: region.Region, value: region.ID })));
    setOrderType(filters.OrderType.map(order => ({ label: order.label, value: order.value })));
    setOnlyRealizedSales(filters.OnlyRealizedSales);
    setIncludeVoidedInvoices(filters.IncludeVoidedInvoices);
    setStates(filters?.States?.map(state => ({ label: state?.Abbreviation, value: state?.ID })));
    setInvoiceType(filters.InvoiceType.map(invoice => ({ label: invoice.label, value: invoice.value })));
    if(filters.Timeframe === "week") {
      setTimeframe({label:"This week", value: filters.Timeframe});
    }
    else if(filters.Timeframe === "month") {
      setTimeframe({label:"This month", value: filters.Timeframe});
    }
    else if(filters.Timeframe === "last-month") {
      setTimeframe({label:"Last month", value: filters.Timeframe});
    }
    else if(filters.Timeframe === "custom") {
      setTimeframe({label:"Custom", value: filters.Timeframe});
      setCustomStartDate(dayjs(filters.CustomStartDate));
      setCustomEndDate(dayjs(filters.CustomEndDate));
    }
    // setInvoiceType(filters.InvoiceType.map(invoice => ({ label: invoice.InvoiceTypeName, value: invoice.ID })));
  };

  useEffect(() => {
    // Fetch initial data or perform any setup actions
    if (!userData.Reports) {
      navigate('/');
    }
    if (reportID) {
      // Fetch report data using reportID
      getExistingReport();
    }
  }, [reportID]);

  return (
    <ModalView
      isOpen={openRunNewReport}
      onClose={handleRunNewReport}
      modalTitle="All Sales Report"
      textInputComponent={
        <>
          <div className="sales-report-modal-field">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
              className="text-label"
            >
              <Text variant="bodyText">Timeframe</Text>
            </div>

            <DropdownComponent
              label=""
              placeholder=""
              options={[
                { label: "This week", value: "week" },
                { label: "This Month", value: "month" },
                { label: "Last Month", value: "last-month" },
                { label: "Custom", value: "custom" },
              ]}
              value={timeframe}
              setValue={setTimeframe}
            />
            {timeframe.value === "custom" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText=""
                  value={customStartDate}
                  setValue={setCustomStartDate}
                />
                <Text variant="bodyText">to</Text>
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText=""
                  value={customEndDate}
                  setValue={setCustomEndDate}
                />
              </div>
            )}
          </div>
            <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">States</Text>
            </div>
            <div className="text-input">
              <LazyEntitySelect
                value={states}
                onChange={setStates}
                placeholder="Search states..."
                apiPath={apiPath}
                staticParams={{ type: "states" }}
              />
            </div>
          </div>
          <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">Regions</Text>
            </div>
            <div className="text-input">
              <LazyEntitySelect
                value={regions}
                onChange={setRegions}
                placeholder="Search regions..."
                apiPath={apiPath}
                staticParams={{ type: "regions" }}
              />
            </div>
          </div>
          <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">Manufacturers</Text>
            </div>
            <div className="text-input">
              <LazyEntitySelect
                value={manufacturers}
                onChange={setManufacturers}
                placeholder="Search manufacturers..."
                apiPath={apiPath}
                staticParams={{ type: "manufacturers" }}
              />
            </div>
          </div>
          <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">Product Groups</Text>
            </div>
            <div className="text-input">
              <LazyEntitySelect
                value={productGroups}
                onChange={setProductGroups}
                placeholder="Search product groups..."
                apiPath={apiPath}
                staticParams={{ type: "productgroups" }}
              />
            </div>
          </div>
          <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">Distributors</Text>
            </div>
            <div className="text-input">
              <LazyEntitySelect
                value={distributors}
                onChange={setDistributors}
                placeholder="Search distributors..."
                apiPath={apiPath}
                staticParams={{ type: "distributors" }}
              />
            </div>
          </div>
          <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">Accounts</Text>
            </div>
            <div className="text-input">
              <LazyEntitySelect
                value={accounts}
                onChange={setAccounts}
                placeholder="Search accounts..."
                apiPath={apiPath}
                staticParams={{ type: "accounts" }}
                mapItem={(x) => ({
                  value: x.ID,
                  label: x.Name,
                  RegionID: x.RegionID ?? null, // 👈 keep RegionID on the option
                })}
              />
            </div>
          </div>
          <div
            className="sales-report-modal-field"
            style={{ alignSelf: "stretch" }}
          >
            <div className="text-label">
              <Text variant="bodyText">Order Type</Text>
            </div>
            <div className="text-input">
              <MultiSelectInput
                type="NonAsync"
                placeholder="Direct Order / Product Usage"
                value={orderType}
                setValue={setOrderType}
                options={[
                  { label: "Direct Order", value: "Direct Order" },
                  { label: "Product Usage", value: "Product Usage" },
                  // { label: "Both", value: "Both" }
                ]}
                labelKey="label"
                labelValue="value"
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "12px",
                }}
              >
                <Checkbox
                  style={{ transform: "scale(1.25)" }}
                  value={onlyRealizedSales}
                  onChange={(e) => setOnlyRealizedSales(e.target.checked)}
                />
                <Text variant="bodyText">
                  Include only realized sales — orders which are invoiced
                </Text>
              </div>
            </div>
          </div>
          {onlyRealizedSales &&
            <div
              className="sales-report-modal-field"
              style={{ alignSelf: "stretch" }}
            >
              <div className="text-label">
                <Text variant="bodyText">Invoice Status</Text>
              </div>
              <div className="text-input">
                <MultiSelectInput
                  type="NonAsync"
                  placeholder="Open Balance / Past Due / Fully Paid"
                  value={invoiceType}
                  setValue={setInvoiceType}
                  options={[
                    { label: "Open Balance", value: "Open Balance" },
                    { label: "Past Due", value: "Past Due" },
                    { label: "Fully Paid", value: "Fully Paid" },
                  ]}
                  labelKey="label"
                  labelValue="value"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: "12px",
                  }}
                >
                  <Checkbox 
                    style={{ transform: "scale(1.25)" }} 
                    value={includeVoidedInvoices}
                    onChange={(e) => setIncludeVoidedInvoices(e.target.checked)}
                  />
                  <Text variant="bodyText">Include voided invoices</Text>
                </div>
              </div>
            </div>
          }
        </>
      }
      footerButtonWrapper={
        <div className="footer-button-wrapper">
          <Button variant="table" subVariant="primary" onClick={runReport}>
            {reportID ? "Update Report" : "Run Report"}
          </Button>
        </div>
      }
    />
  );
};

export default NewReport;
